export const COUNTRIES = [
  { id: "GA", name: "Gabon" },
  { id: "GB", name: "United Kingdom of Great Britain and Northern Ireland" },
  // { id: "GD", name: "Grenada" },
  // { id: "GE", name: "Georgia" },
  // { id: "GF", name: "French Guiana" },
  // { id: "GG", name: "Guernsey" },
  // { id: "GH", name: "Ghana" },
  // { id: "GI", name: "Gibraltar" },
  // { id: "GL", name: "Greenland" },
  // { id: "GM", name: "Gambia" },
  // { id: "GN", name: "Guinea" },
  // { id: "GP", name: "Guadeloupe" },
  // { id: "GQ", name: "Equatorial Guinea" },
  // { id: "GR", name: "Greece" },
  // { id: "GS", name: "South Georgia and the South Sandwich Islands" },
  // { id: "GT", name: "Guatemala" },
  { id: "GU", name: "Guam" },
  { id: "GW", name: "Guinea-Bissau" },
  { id: "GY", name: "Guyana" },
  { id: "HK", name: "Hong Kong" },
  { id: "HM", name: "Heard Island and McDonald Islands" },
  { id: "HN", name: "Honduras" },
  { id: "HR", name: "Croatia" },
  { id: "HT", name: "Haiti" },
  { id: "HU", name: "Hungary" },
  { id: "ID", name: "Indonesia" },
  { id: "IE", name: "Ireland" },
  { id: "IL", name: "Israel" },
  { id: "IM", name: "Isle of Man" },
  { id: "IN", name: "India" },
  { id: "IO", name: "British Indian Ocean Territory" },
  { id: "IQ", name: "Iraq" },
  { id: "IR", name: "Iran, Islamic Republic of" },
  { id: "IS", name: "Iceland" },
  { id: "IT", name: "Italy" },
  { id: "JE", name: "Jersey" },
  { id: "JM", name: "Jamaica" },
  { id: "JO", name: "Jordan" },
  { id: "JP", name: "Japan" },
  { id: "KE", name: "Kenya" },
  { id: "KG", name: "Kyrgyzstan" },
  { id: "KH", name: "Cambodia" },
  { id: "KI", name: "Kiribati" },
  // { id: "KM", name: "Comoros" },
  // { id: "KN", name: "Saint Kitts and Nevis" },
  // { id: "KP", name: "Korea, Democratic People's Republic of" },
  // { id: "KR", name: "Korea, Republic of" },
  // { id: "KW", name: "Kuwait" },
  // { id: "KY", name: "Cayman Islands" },
  // { id: "KZ", name: "Kazakhstan" },
  // { id: "LA", name: "Lao People's Democratic Republic" },
  // { id: "LB", name: "Lebanon" },
  // { id: "LC", name: "Saint Lucia" },
  // { id: "LI", name: "Liechtenstein" },
  { id: "LK", name: "Sri Lanka" },
  { id: "LR", name: "Liberia" },
  { id: "LS", name: "Lesotho" },
  { id: "LT", name: "Lithuania" },
  { id: "LU", name: "Luxembourg" },
  { id: "LV", name: "Latvia" },
  { id: "LY", name: "Libya" },
  { id: "MA", name: "Morocco" },
  { id: "MC", name: "Monaco" },
  // { id: "MD", name: "Moldova, Republic of" },
  // { id: "ME", name: "Montenegro" },
  // { id: "MF", name: "Saint Martin (French part)" },
  // { id: "MG", name: "Madagascar" },
  // { id: "MH", name: "Marshall Islands" },
  // { id: "MK", name: "North Macedonia" },
  // { id: "ML", name: "Mali" },
  // { id: "MM", name: "Myanmar" },
  // { id: "MN", name: "Mongolia" },
  // { id: "MO", name: "Macao" },
  { id: "MP", name: "Northern Mariana Islands" },
  { id: "MQ", name: "Martinique" },
  { id: "MR", name: "Mauritania" },
  { id: "MS", name: "Montserrat" },
  { id: "MT", name: "Malta" },
  { id: "MU", name: "Mauritius" },
  { id: "MV", name: "Maldives" },
  // { id: "MW", name: "Malawi" },
  // { id: "MX", name: "Mexico" },
  // { id: "MY", name: "Malaysia" },
  // { id: "MZ", name: "Mozambique" },
  // { id: "NA", name: "Namibia" },
  // { id: "NC", name: "New Caledonia" },
  // { id: "NE", name: "Niger" },
  // { id: "NF", name: "Norfolk Island" },
  // { id: "NG", name: "Nigeria" },
  { id: "NI", name: "Nicaragua" },
  { id: "NL", name: "Netherlands" },
  { id: "NO", name: "Norway" },
  { id: "NP", name: "Nepal" },
  { id: "NR", name: "Nauru" },
  { id: "NU", name: "Niue" },
  { id: "NZ", name: "New Zealand" },
  // { id: "OM", name: "Oman" },
  // { id: "PA", name: "Panama" },
  // { id: "PE", name: "Peru" },
  // { id: "PF", name: "French Polynesia" },
  // { id: "PG", name: "Papua New Guinea" },
  // { id: "PH", name: "Philippines" },
  // { id: "PK", name: "Pakistan" },
  // { id: "PL", name: "Poland" },
  // { id: "PM", name: "Saint Pierre and Miquelon" },
  // { id: "PN", name: "Pitcairn" },
  // { id: "PR", name: "Puerto Rico" },
  // { id: "PS", name: "Palestine, State of" },
  // { id: "PT", name: "Portugal" },
  // { id: "PW", name: "Palau" },
  // { id: "PY", name: "Paraguay" },
  // { id: "QA", name: "Qatar" },
  // { id: "RE", name: "Réunion" },
  { id: "RO", name: "Romania" },
  { id: "RS", name: "Serbia" },
  { id: "RU", name: "Russian Federation" },
  { id: "RW", name: "Rwanda" },
  { id: "SA", name: "Saudi Arabia" },
  { id: "SB", name: "Solomon Islands" },
  { id: "SC", name: "Seychelles" },
  { id: "SD", name: "Sudan" },
  { id: "SE", name: "Sweden" },
  { id: "SG", name: "Singapore" },
  { id: "SH", name: "Saint Helena, Ascension and Tristan da Cunha" },
  { id: "SI", name: "Slovenia" },
  { id: "SJ", name: "Svalbard and Jan Mayen" },
  { id: "SK", name: "Slovakia" },
  { id: "SL", name: "Sierra Leone" },
  { id: "SM", name: "San Marino" },
  { id: "SN", name: "Senegal" },
  { id: "SO", name: "Somalia" },
  { id: "SR", name: "Suriname" },
  // { id: "SS", name: "South Sudan" },
  // { id: "ST", name: "Sao Tome and Principe" },
  // { id: "SV", name: "El Salvador" },
  // { id: "SX", name: "Sint Maarten (Dutch part)" },
  // { id: "SY", name: "Syrian Arab Republic" },
  // { id: "SZ", name: "Eswatini" },
  // { id: "TC", name: "Turks and Caicos Islands" },
  // { id: "TD", name: "Chad" },
  { id: "TF", name: "French Southern Territories" },
  { id: "TG", name: "Togo" },
  { id: "TH", name: "Thailand" },
  { id: "TJ", name: "Tajikistan" },
  { id: "TK", name: "Tokelau" },
  { id: "TL", name: "Timor-Leste" },
  { id: "TM", name: "Turkmenistan" },
  { id: "TN", name: "Tunisia" },
  // { id: "TO", name: "Tonga" },
  // { id: "TR", name: "Türkiye" },
  // { id: "TT", name: "Trinidad and Tobago" },
  // { id: "TV", name: "Tuvalu" },
  // { id: "TW", name: "Taiwan, Province of China" },
  // { id: "TZ", name: "Tanzania, United Republic of" },
  // { id: "UA", name: "Ukraine" },
  // { id: "UG", name: "Uganda" },
  { id: "UM", name: "United States Minor Outlying Islands" },
  { id: "US", name: "United States of America" },
  { id: "UY", name: "Uruguay" },
  { id: "UZ", name: "Uzbekistan" },
  { id: "VA", name: "Holy See" },
  { id: "VC", name: "Saint Vincent and the Grenadines" },
  { id: "VE", name: "Venezuela, Bolivarian Republic of" },
  // { id: "VG", name: "Virgin Islands (British)" },
  // { id: "VI", name: "Virgin Islands (U.S.)" },
  // { id: "VN", name: "Viet Nam" },
  // { id: "VU", name: "Vanuatu" },
  // { id: "WF", name: "Wallis and Futuna" },
  // { id: "WS", name: "Samoa" },
  // { id: "YE", name: "Yemen" },
  // { id: "YT", name: "Mayotte" },
  // { id: "ZA", name: "South Africa" },
  { id: "ZM", name: "Zambia" },
  { id: "ZW", name: "Zimbabwe" }
];
